module.exports = __webpack_public_path__ + "static/media/U1-T2-3-1e.5c21a2c0.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vo/U1-T2-3-1e.mp3
// module id = 577
// module chunks = 0